// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"18879cad7fde2b88","5405":"5e843e6648162e5b"}[chunkId] + ".css";
};